// import TaskEngine from './TaskEngine';
import TaskEngineV2 from './TaskEngineV2';
import TaskEngineV3 from './TaskEngineV3';

export default {
  displayNameKey: 'task_engine',
  icon: 'menu_te',
  pages: {
    // TaskEngine,
    TaskEngineV2,
    TaskEngineV3,
  },
};



// WEBPACK FOOTER //
// ./src/modules/TaskEngine/index.js